<section class="centered-with-padding flex flex-col gap-y-3 py-5">
  @if (data.title; as title) {
    <app-title [title]="title" size="custom-20-22" />
  }
  @if (data.text; as text) {
    <div [innerHtml]="text" class="prose prose-custom-marker max-w-none leading-tight" handleHtmlLinks></div>
  }
  @if (data.infoCard; as infoCard) {
    <div class="grid grid-cols-[auto_1fr] items-center gap-x-4 rounded-2xl bg-gray-light p-4">
      <app-svg [inline]="true" [width]="21" src="assets/icons/info.svg" />
      <span>{{ infoCard }}</span>
    </div>
  }
</section>
